const ANIMATE_ADD_TO_CART_CLASS = 'sf-spinner-loading';
const CART_FORM_SELECTOR = '.checkout-form';

init();

/**
 * Inits the listener for adding new items to the cart from the PLP.
 */
function init() {
  const cartForm = document.querySelector(CART_FORM_SELECTOR);

  const blockedClass = 'js-blocked';

  const cntrs = document.querySelectorAll('.sf-cart-count');
  document.addEventListener('click', async (event) => {
    const target = findAncestor(event.target, (el) => el.hasAttribute('data-add-to-cart'), 10);
    if (!target) {
      return;
    }

    const id = target.getAttribute('data-add-to-cart');
    if (!id) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (target.classList.contains(blockedClass)) {
      return;
    }

    target.classList.add(blockedClass);

    try {
      await addItemToCart([['id', id]]);
    } catch (err) {
      target.classList.remove(blockedClass);
      return;
    }

    try {
      await refreshCart(cartForm, cntrs);
    } catch (err) {
      window.console.log(err);
    }

    target.classList.remove(blockedClass);
  });
}

async function refreshCart(cartForm, cntrs) {
  window.Shopify.onCartUpdate();
  const call = await Promise.all([updateCartCounters(cntrs), fetchCart()]);
  cartForm.innerHTML = call[1];
}

async function fetchCart() {
  addToCart()
  const res = await window.fetch('/cart?view=product-ajax', {credentials: 'same-origin'});
  const html = await res.text();
  return html;
}

async function fetchCartCount() {
  const res = await window.fetch('/cart.js', {credentials: 'same-origin'});
  const resJSON = await res.json();
  return resJSON.item_count;
}

async function updateCartCounters(cntrs) {
  if (!cntrs || cntrs.lenght === 0) {
    return null;
  }

  const count = await fetchCartCount();

  for (let i = 0; i < cntrs.length; i++) {
    const cntr = cntrs[i];
    cntr.classList.add(ANIMATE_ADD_TO_CART_CLASS);
    cntr.innerHTML = count;
    window.setTimeout(() => cntr.classList.remove(ANIMATE_ADD_TO_CART_CLASS), 1000);
  }

  return null;
}

function addItemToCart(entries) {
  const data = new window.URLSearchParams();
  for (const item of entries) {
    data.append(item[0], item[1]);
  }

  const req = new window.Request('/cart/add.js', {
    method: 'POST',
    body: data,
    credentials: 'same-origin',
  });

  return window.fetch(req, {credentials: 'same-origin'});
}


// {%- assign costprice = 0 -%}
// {%- for item in cart.items -%}
//     {%- assign costprice = costprice | plus: product.metafields.custom.costprice -%}
// {%- endfor -%}
// Sum of product.metafields.custom.costprice = {{ costprice }};
//  window.dataLayer = window.dataLayer || [];
//   window.dataLayer.push({
//  'CP': {{ costprice }}
//  });

